import { createElement, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import shouldPolyfill from './polyfills/should';

// import '../styles/styles.css';// donne un quick preview du css en prod

interface AppProps {
    locale?: string;
    [key: string]: unknown;
}

function getAppProps(): AppProps {
    const propsEl = document.getElementById('app-props');
    return propsEl !== null ? JSON.parse(propsEl.innerHTML) || {} : window.props;
}

function renderApp(Container, props) {
    const element = document.getElementById('app');
    const container = createElement(Container, props);
    const strictMode = createElement(StrictMode, {}, container);
    const root = createRoot(element);
    root.render(strictMode);
}

function loadContainer(props) {
    const { locale = 'fr' } = props;
    return Promise.all([
        import(/* webpackChunkName: "micromag-container" */ './components/Container'),
        locale === 'en' ? import('@micromag/intl/locale/en') : import('@micromag/intl/locale/fr'),
    ]).then(([{ default: Container }]) => Container);
}

const props = getAppProps();

if (shouldPolyfill()) {
    import('./polyfills/index')
        .then(() => loadContainer(props))
        .then((Container) => renderApp(Container, props));
} else {
    loadContainer(props).then((Container) => renderApp(Container, props));
}
